import { useFormContext } from 'react-hook-form';
import DatePicker from '@components/date-picker/DatePicker';
import { isDateRangeValid } from '@src/utils/helpers';
import classNames from 'classnames';

const DateRange = ({
  nameBefore,
  nameAfter,
  labelBefore,
  labelAfter,
  dateBefore,
  required,
  onChange = () => {},
  isOnGoing,
  readOnly,
  className,
}) => {
  const { watch, setValue } = useFormContext();
  const watchNameBefore = watch(nameBefore);
  const watchNameAfter = watch(nameAfter);

  const handleBlur = (e) => {
    // Before date cannot be after the After date
    if (e?.target?.name === nameBefore) {
      if (isDateRangeValid(new Date(e?.target?.value), new Date(watchNameAfter)) === false) {
        setValue(nameAfter, '');
      }
    }
    if (e?.target?.name === nameAfter) {
      if (isDateRangeValid(new Date(watchNameBefore), new Date(e?.target?.value)) === false) {
        setValue(nameBefore, '');
      }
    }
  };

  const setMin = () => (watchNameBefore ? watchNameBefore : dateBefore);

  const pickerStyles = classNames('grid-col-6', className);

  return (
    <div className='grid-row grid-gap-1'>
      <div className={pickerStyles}>
        <DatePicker
          min={dateBefore}
          max={watchNameAfter}
          name={nameBefore}
          onChange={onChange}
          onBlur={handleBlur}
          label={labelBefore}
          readOnly={readOnly}
          required={required}
        />
      </div>
      <div className={pickerStyles}>
        <DatePicker
          min={isOnGoing ? null : setMin()}
          name={nameAfter}
          onChange={onChange}
          onBlur={handleBlur}
          label={labelAfter}
          readOnly={isOnGoing || readOnly}
          required={required}
        />
      </div>
    </div>
  );
};

export default DateRange;
